import { Icon } from '@chakra-ui/react';

export default function MousePointerClickIcon(props) {
  return (
    <Icon
      width='42px'
      height='42px'
      viewBox='0 0 42 42'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M25.6005 5.80049L21.6005 9.60049M7.80049 13.6005L2.00049 12.0005M9.60049 21.6005L5.80049 25.6005M12.0005 2.00049L13.6005 7.80049M15.6745 16.9805C15.5969 16.7978 15.5757 16.5961 15.6136 16.4013C15.6515 16.2064 15.7467 16.0274 15.887 15.887C16.0274 15.7467 16.2064 15.6515 16.4013 15.6136C16.5961 15.5757 16.7978 15.5969 16.9805 15.6745L38.9805 24.6745C39.1763 24.7548 39.3416 24.8952 39.4525 25.0754C39.5635 25.2556 39.6144 25.4664 39.5979 25.6774C39.5815 25.8884 39.4985 26.0887 39.361 26.2496C39.2234 26.4104 39.0384 26.5235 38.8325 26.5725L30.1345 28.6545C29.7754 28.7403 29.4471 28.9237 29.1859 29.1846C28.9247 29.4455 28.7407 29.7735 28.6545 30.1325L26.5745 38.8325C26.526 39.0391 26.4131 39.2249 26.252 39.363C26.091 39.5012 25.8901 39.5845 25.6786 39.601C25.467 39.6175 25.2557 39.5663 25.0752 39.4547C24.8947 39.3432 24.7544 39.1771 24.6745 38.9805L15.6745 16.9805Z'
        stroke='currentColor'
        strokeWidth='4'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </Icon>
  );
}
